const initialState = {
  is_open: false
}

export default (state = initialState, action) => {
  switch (action.type) {
    case 'BULK_TOOLBAR_SET_OPEN':
      return { ...state, is_open: Boolean(action.payload) }
    default:
      return state
  }
}
